import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const fetchProducts = async (params = {}) => {
  const { data } = await api.get("/products", { params });
  return data;
};

export const fetchProduct = async (handle) => {
  const { data } = await api.get(`/products/${handle}`);
  return data;
};

export const fetchMeta = async () => {
  const { data } = await api.get("/products/meta");
  return data;
};

export const createShopifyCart = async (lines, discountCode = null) => {
  const payload = { lines };
  if (discountCode) payload.discount_code = discountCode;
  const { data } = await api.post("/cart", payload);
  return data;
};

export const aiSmartSearch = async (query) => {
  const { data } = await api.post("/ai/search", { query });
  return data;
};

// --- Klaviyo tracking ---
const KLAVIYO_EMAIL_KEY = "doria_customer_email_v1";

export const setCustomerEmail = (email) => {
  try {
    if (email && /^\S+@\S+\.\S+$/.test(email)) {
      localStorage.setItem(KLAVIYO_EMAIL_KEY, email.trim().toLowerCase());
    }
  } catch (e) { /* ignore */ }
};

export const getCustomerEmail = () => {
  try {
    return localStorage.getItem(KLAVIYO_EMAIL_KEY);
  } catch (e) {
    return null;
  }
};

export const trackKlaviyo = (event, properties = {}, uniqueId = null) => {
  const email = getCustomerEmail();
  if (!email) return; // no email, nothing to track (guest)
  // Fire and forget
  api.post("/klaviyo/track", { email, event, properties, unique_id: uniqueId }).catch(() => {});
};

export const streamChat = (sessionId, message, onDelta, onDone, onError, { quizContext, productContext, onProducts } = {}) => {
  const controller = new AbortController();
  fetch(`${API}/ai/chat/stream`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ session_id: sessionId, message, quiz_context: quizContext || null, product_context: productContext || null }),
    signal: controller.signal,
  })
    .then(async (res) => {
      const reader = res.body.getReader();
      const decoder = new TextDecoder();
      let buffer = "";
      while (true) {
        const { done, value } = await reader.read();
        if (done) break;
        buffer += decoder.decode(value, { stream: true });
        const parts = buffer.split("\n\n");
        buffer = parts.pop();
        for (const p of parts) {
          const line = p.trim();
          if (!line.startsWith("data:")) continue;
          const payload = line.slice(5).trim();
          try {
            const obj = JSON.parse(payload);
            if (obj.delta) onDelta(obj.delta);
            if (obj.products && onProducts) onProducts(obj.products);
            if (obj.done) onDone && onDone();
            if (obj.error) onError && onError(obj.error);
          } catch (err) { console.debug("stream chunk parse", err); }
        }
      }
      onDone && onDone();
    })
    .catch((e) => { if (e.name !== "AbortError") onError && onError(e.message); });
  return controller;
};
